import ChristmasLogo from '../../assets/img/ChristmasGIFLoader.gif';
import EPRLogo from '../../assets/img/EPR_Recykal.svg';
import NewYearLogo from '../../assets/img/new_year_epr_loop.gif';
import { ChristmasLoader } from '../Components/Loader/ChristmasLoader';
import NewYearLoader from '../Components/Loader/NewYearLoader';
import RecykalLogoLoader from '../Components/Loader/RecykalLogoLoader';

export const LOGO_LOADER_MAP = {
  normal: {
    logo: EPRLogo,
    loader: RecykalLogoLoader,
  },
  christmas: {
    logo: ChristmasLogo,
    loader: ChristmasLoader,
  },
  new_year: {
    logo: NewYearLogo,
    loader: NewYearLoader,
  },
};
